import { GridAction } from '@eforall/dashboard';
import { Award } from '@interfaces';

export function getActions() {

	const actions: GridAction<Award>[] = [];

	return actions;
}
